import rem from '@/utils/rem'
import classname from 'classnames'

const Input = ({ ['data-testid']: dataTestId = 'input', id, name, register, type = "text", disabled = false, error, placeholder, validation, errorMessage, label, sizing = 'default', maxWidth, prefix, addClass, cancelIcon, handleOnCancel, fullWidth, showPipe = false, pipeText, ...inputProps }) => {

	const sizingOptions = {
		DEFAULT: 'default',
		MEDIUM: 'medium'
	}

	const inputStyles = {
		maxWidth: rem(maxWidth)
	}

	const inputClass = classname(
		addClass,
		{
			'input-field': true,
			'input-field--full-width': fullWidth,
			'input-field--disabled': disabled,
			'input-field--successful': validation,
			'input-field--error': error,
			'input-field--prefix': prefix,
			'input-field--medium': sizing === sizingOptions.MEDIUM
		}
	)

	const ValidateError = () => {
		//Custom setError message is an object
		if (error && errorMessage?.message) {
			return (
				<span className='t--required'>{errorMessage.message}</span>
			)
		}

		if (error) {
			return (
				<span className='t--required'>{errorMessage}</span>
			)
		}

		return (
			<></>
		)
	}

	return (
		<div className={inputClass} style={inputStyles}>
			{prefix && (
				<div className='input-field__prefix'>{prefix}</div>
			)}
			{label && (
				<label className='input-field__label' htmlFor={name}>{label}</label>
			)}
			<div className={`input-field__input ${(showPipe && "input-field__input-pipe") || ""}`}>
				<input
					id={id || name}
					name={name}
					type={type}
					placeholder={placeholder}
					ref={register}
					disabled={disabled}
					data-testid={dataTestId}
					{...inputProps}
				/>
				{showPipe && (
					<div className='input-field__pipe-text'>{pipeText}</div>
				)}
			</div>
			{cancelIcon && inputProps?.value?.length ? (
				<div
					className='input-field__cancel-icon'
					data-testid={`${dataTestId}-cancel`}
					onClick={() => {
						if (handleOnCancel) return handleOnCancel()
						else inputProps.onChange({ target: { value: '' } })
					}}
				>
					{cancelIcon}
				</div>
			) : <></>}
			<ValidateError />
		</div>
	)
}

export default Input
